import http from '@/http'

export default {
  state: () => ({
    user: {}
  }),

  getters: {},

  mutations: {
    setUser(state, user) {
      state.user = user
    }
  },

  actions: {
    async fetchUser({ commit }) {
      let { data } = await http.get('/profile')
      commit('setUser', data.user)
    },

    async updateUser({ commit }, user) {
      await http.post('/profile', user)

     // if (response.succes_update) {
        commit('setUser', user)
     // } else {
     //   throw new HTTPException('Пользователь уже обновлен')
     // }
    }
  },

  namespaced: true
}
